export default __webpack_public_path__ + "static/media/Keys.d49835d5.svg";